@if (rect(); as _rect) {
  <div class="asset-transitioner" [style.--asset-background-color]="theme()?.asset_page.background_color">
    <div
      class="asset-container"
      [class.show-tile-bg]="showTileBg()"
      [class.opening]="opening()"
      [class.closing]="closing()"
      [style.top]="_rect.y + 'px'"
      [style.left]="_rect.x + 'px'"
      [style.width]="_rect.width + 'px'"
      [style.height]="_rect.height + 'px'"
    >
      @if (nonPreviewAsset()) {
        <app-non-preview-file
          [asset]="nonPreviewAsset()"
          [gallery]="gallery()"
          [darkBackground]="darkBackground()"
          [showSizeAndDownload]="opening()"
          [showFilename]="opening() || theme()?.section.show_filenames"
          [showBorder]="false"
        ></app-non-preview-file>
      } @else {
        <img [src]="url()" alt="" [class.fade-away]="fadeOut()" #asset />
      }
    </div>
    @if (showBackgroundIn()) {
      <div class="transition-asset-bg" [@transitionAssetBgIn]></div>
    }
    @if (showBackgroundOut()) {
      <div class="transition-asset-bg" [@transitionAssetBgOut]></div>
    }
  </div>
}
